export default function SunsetIcon({
  color = "#000000",
  width = "100%",
  height = "100%",
}) {
  return (
    <svg
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 512.001 512.001"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <g>
          <g>
            <rect x="245.551" y="138.449" width="20.898" height="47.02" />
            <rect x="381.388" y="253.388" width="47.02" height="20.898" />
            <rect x="83.592" y="253.388" width="47.02" height="20.898" />
            <rect
              x="339.59"
              y="178.975"
              transform="matrix(0.7071 0.7071 -0.7071 0.7071 244.7538 -188.602)"
              width="20.898"
              height="44.335"
            />
            <rect
              x="134.566"
              y="190.689"
              transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 125.3337 454.1906)"
              width="44.335"
              height="20.898"
            />
            <path d="M512,305.633H370.459c-5.298-58.498-54.604-104.49-114.459-104.49s-109.162,45.992-114.459,104.49H0v20.898h512V305.633z M162.543,305.633c5.214-46.953,45.134-83.592,93.457-83.592s88.243,36.638,93.457,83.592H162.543z" />
          </g>
        </g>
      </g>
    </svg>
  );
}
